/**
 * BriqueChart Component의 Main JS
 *   - Plotly 상속
 *   - 각종 Mixin 파일들을 Assign
 *   - Modal에 전달할 데이터를 가지고 있음
 */

import Vue from 'vue'
import VueJsonToCsv from 'vue-json-to-csv'
// import { _ } from 'core-js'
import BriqueChartModal from './Modal/BriqueChartModal.vue'
import BriqueChartModalColor from './Modal/BriqueChartModalColor.vue'
import BriqueChartModalMarker from './Modal/BriqueChartModalMarker.vue'
import BriqueChartModalChartType from './Modal/BriqueChartModalChartType.vue'
import BriqueChartModalDataGrid from './Modal/BriqueChartModalDataGrid.vue'

import BriqueChartBaseMixin from './BriqueChartBaseMixin.js'
import BriqueChartMinMaxMixin from './BriqueChartMinMaxMixin.js'

import BriqueChartOptionMixin from './BriqueChartOptionMixin.js'
import BriqueChartDataMixin from './BriqueChartDataMixin.js'

import BriqueChartDataOptionMixin from './BriqueChartDataOptionMixin.js'
import BriqueChartLayoutMixin from './BriqueChartLayoutMixin.js'
import BriqueChartConfigMixin from './BriqueChartConfigMixin.js'
import BriqueChartModebarButtonMixin from './BriqueChartModebarButtonMixin.js'
import BriqueChartModebarButtonEventMixin from './BriqueChartModebarButtonEventMixin.js'

import BriqueChartPlotlyOverrideMixin from './BriqueChartPlotlyOverrideMixin.js'

import BriqueChartLegendMixin from './BriqueChartLegendMixin.js'
import BriqueChartTooltipMixin from './BriqueChartTooltipMixin.js'
import BriqueChartPaletteMixin from './BriqueChartPaletteMixin.js'
import BriqueChartSamplingMixin from './BriqueChartSamplingMixin.js'
import BriqueChartModalMixin from './BriqueChartModalMixin.js'
import BriqueChartModalColorMixin from './BriqueChartModalColorMixin.js'
import BriqueChartModalMarkerMixin from './BriqueChartModalMarkerMixin.js'
import BriqueChartModalChartTypeMixin from './BriqueChartModalChartTypeMixin.js'

import BriqueChartXAxisMixin from './BriqueChartXAxisMixin.js'
import BriqueChartYAxisMixin from './BriqueChartYAxisMixin.js'
import BriqueChartPointContextMenuMixin from './BriqueChartPointContextMenuMixin.js'
import BriqueChartLegendContextMenuMixin from './BriqueChartLegendContextMenuMixin.js'

Vue.component(BriqueChartModal.name, BriqueChartModal)
Vue.component(BriqueChartModalColor.name, BriqueChartModalColor)
Vue.component(BriqueChartModalMarker.name, BriqueChartModalMarker)
Vue.component(BriqueChartModalChartType.name, BriqueChartModalChartType)
Vue.component(BriqueChartModalDataGrid.name, BriqueChartModalDataGrid)
Vue.component('vue-json-to-csv', VueJsonToCsv)

let BriqueChart = {
  name: 'BriqueChart',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {

  },
  methods: {
    /**
     * 차트 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {Object} modalData 차트 모달에서 설정한 데이터
     * @param {Object} oldModalData 이전에 차트 모달에서 설정한 데이터
     */
    onClickConfirmButtonInModal (returnObject, modalData, oldModalData) {
      BriqueChart.onClickConfirmButtonInModal(returnObject, this, modalData, oldModalData)
    },

    /**
     * 차트 Color 선택 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {String} seriesName Series Name
     * @param {Object} colors 선택된 색
     */
    onClickConfirmButtonInModalColor (returnObject, seriesName, colors) {
      BriqueChart.onClickConfirmButtonInModalColor(returnObject, this, seriesName, colors)
    },

    /**
     * 차트 Marker Symbol 선택 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {String} seriesName Series Name
     * @param {Object} data 선택된 data
     */
    onClickConfirmButtonInModalMarker (returnObject, seriesName, data) {
      BriqueChart.onClickConfirmButtonInModalMarker(returnObject, this, seriesName, data)
    },

    /**
     * 차트 Type 선택 모달에서 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     * @param {String} seriesName Series Name
     * @param {Object} data 선택된 data
     */
    onClickConfirmButtonInModalChartType (returnObject, seriesName, data) {
      BriqueChart.onClickConfirmButtonInModalChartType(returnObject, this, seriesName, data)
    },
    /**
     * Export CSV data
     * @param {*} data export json data
     */
    exportCsvData (data) {
      this.chartDataCsv = data
      setTimeout(() => {
        this.$refs.briqueGridExportCsv.$el.click()
      })
    }
  }, // end - methods
  data () {
    return {
      chartModal: { // 차트 모달에서 사용할 데이터
        visible: false,
        tabStep: 'palette',
        chartData: [], // 차트 원본 데이터
        chartTitle: ''
      },

      chartModalColor: { // 차트 모달에서 사용할 데이터
        visible: false,
        chartData: [], // 차트 원본 데이터
        seriesName: '',
        beforeColor: ''
      },

      chartModalMarker: { // 차트 모달에서 사용할 데이터
        visible: false,
        chartData: [], // 차트 원본 데이터
        seriesName: '',
        beforeSymbol: '',
        beforeSize: 6
      },

      chartModalChartType: { // 차트 모달에서 사용할 데이터
        visible: false,
        chartData: [], // 차트 원본 데이터
        seriesName: '',
        beforeType: ''
      },

      chartModalDataGrid: { // 차트 모달에서 사용할 데이터 (Grid)
        visible: false,
        chartData: [], // 차트 원본 데이터
        chartTitle: ''
      },

      splitCharts: [// 스플릿 차트의 데이터(차트 모달에서 설정한 데이터를 토대로 만들어짐), Object의 key : id
        // {
        //   id: 'splitChart_1',
        //   title: '상위차트명_스플릿 차트',
        //   seriesList: {
        //     name: 'Series1',
        //     checked: true
        //   }
        // }
      ],
      xAxisContextMenu: BriqueChart.getXAxisContextMenu(this),
      yAxisContextMenu: BriqueChart.getYAxisContextMenu(this),
      legendContextMenu: BriqueChart.getLegendContextMenu(this),
      // visibleYaxisContextMenu: false,

      // xAxisDataSelectionName: ''// X축 데이터 선택 리스트(차트 모달에서 설정한 데이터를 토대로 만들어짐
      chartDataCsv: []
    }
  } // end-data()
}

Object.assign(
  BriqueChart,
  BriqueChartBaseMixin,
  BriqueChartMinMaxMixin,
  BriqueChartOptionMixin,
  BriqueChartDataMixin,
  BriqueChartLayoutMixin,
  BriqueChartDataOptionMixin,
  BriqueChartConfigMixin,
  BriqueChartModebarButtonMixin,
  BriqueChartModebarButtonEventMixin,
  BriqueChartPlotlyOverrideMixin,
  BriqueChartLegendMixin,
  BriqueChartTooltipMixin,
  BriqueChartPaletteMixin,
  BriqueChartSamplingMixin,
  BriqueChartModalMixin,
  BriqueChartModalColorMixin,
  BriqueChartModalMarkerMixin,
  BriqueChartModalChartTypeMixin,
  BriqueChartXAxisMixin,
  BriqueChartYAxisMixin,
  BriqueChartPointContextMenuMixin,
  BriqueChartLegendContextMenuMixin
)

export default BriqueChart
